import React from 'react';
import { useSnapshot } from 'valtio';
import SettingsSaveNotice from '../../components/SettingsSaveNotice';
import { schedulingSettingsReady, supportsScheduleProtocol } from '../../Utils/scheduling_utils';
import {
  discardScheduleDraft, keepScheduleDraft, scheduleDraftSubmission, scheduleSubmissionMessage
} from '../../Utils/scheduling_transaction';
import { useScheduleSubmissionTimeout } from './useScheduleDraft';
import useSchedulingEnabled from '../../Hooks/useSchedulingEnabled';

export default function ScheduleSaveStatus({ controller, parent }) {
  const schedulingEnabled = useSchedulingEnabled();
  const live = useSnapshot(controller);
  const snapshot = useSnapshot(parent);
  const submission = scheduleDraftSubmission(snapshot);
  useScheduleSubmissionTimeout(parent, snapshot.schedule_submission);
  const settings = snapshot.settings.scheduling;
  if (!schedulingEnabled || !live.access_rights?.scheduling?.read || !supportsScheduleProtocol(live, settings)) return null;
  const ready = schedulingSettingsReady(settings);
  const writable = Boolean(live.access_rights?.scheduling?.write);
  const pin = snapshot.temp_settings?.scheduling?._editing_phase;
  const phaseMissing = pin && !settings?.schedule_values?.scheduling_values.some((phase) => phase.phase_id === pin.phase_id);
  const message = submission ? scheduleSubmissionMessage(submission) : '';
  return <SettingsSaveNotice status={submission?.status}
    message={message} scope={message.startsWith('settings_upload_') ? 'scheduling' : undefined} helpId="schedule_save_help"
    onUseController={writable ? () => {
      if (controller.access_rights?.scheduling?.write) discardScheduleDraft(parent);
    } : undefined}
    onKeep={() => { if (controller.access_rights?.scheduling?.write) keepScheduleDraft(parent); }}
    keepDisabled={!ready || Boolean(phaseMissing)} />;
}
